import ValidatorResult from "../classes/validator.results";
export default class MinLengthValidationRule {
    name = 'minlen';
    validate(validation, rule, value, object, manager) {
        //Message
        let tMessage = appHost.localizer?.t('system.Validation.StringLengthMin', [validation.displayName, '', rule.props]);
        //Data
        if (value === undefined || value === null) {
            return new ValidatorResult(true);
        }
        if (/(string|array)/.test(typeof value) === false)
            return new ValidatorResult(false, tMessage);
        if (value.length > 0 && value.length < rule.props)
            return new ValidatorResult(false, tMessage);
        return new ValidatorResult(true);
    }
}
